import * as types from "./actionTypes";

export function setSelectedLink(selectedLink: string) {
  return { type: types.SET_SELECTED_LINK, payload: selectedLink };
}
export function setSelectedPriority(selectedPriority: string[]) {
  return { type: types.SET_SELECTED_PRIORITY, payload: selectedPriority };
}
export function setPriorityOptions(priorityOptions: { label: string, id: number, color: string }[]) {
  return { type: types.SET_PRIORITY_OPTIONS, payload: priorityOptions };
}
export function setTreatmentOptions(treatmentOptions: { label: string, id: number, color: string }[]) {
  return { type: types.SET_TREATMENT_OPTIONS, payload: treatmentOptions };
}
export function setStructureOptions(structureOptions: { label: string, id: number, color: string }[]) {
  return { type: types.SET_STRUCTURE_OPTIONS, payload: structureOptions };
}